import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ServicerQueueRowSchema = withDefaults({
  type: 'servicer-queue-row',
  objectExtensions: ['servicer-queue-row'],
  fields: [
    { kind: 'attribute', name: 'status' },
    { kind: 'attribute', name: 'rawText' },
    { kind: 'attribute', name: 'resolutionId' },
    { kind: 'attribute', name: 'personId' },
    { kind: 'attribute', name: 'personName' },
    { kind: 'attribute', name: 'documentId' },
    { kind: 'attribute', name: 'documentProvider' },
    { kind: 'attribute', name: 'documentReflectionState' },
    { kind: 'attribute', name: 'documentUploadedAt' },
    { kind: 'attribute', name: 'selectedServicer' },
    { kind: 'attribute', name: 'appliedServicer' },
    { kind: 'attribute', name: 'overridden' },
    { kind: 'attribute', name: 'submittedAt' },
    { kind: 'attribute', name: 'answeredAt' },
    { kind: 'attribute', name: 'appliedAt' },
    { kind: 'attribute', name: 'reviewedAt' },
    { kind: 'attribute', name: 'patterns' },
  ],
});

export default ServicerQueueRowSchema;
